import React, { useState, useCallback, useEffect, useRef } from "react";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import classNames from "classnames";
import * as c from "./lcNavbar.module.scss";
import LcSearch from "./lcSearch";
import { MangomintLogo } from "@components/ui/mangomintLogo";
import LcNavigationMobile from "./lcNavigationMobile";
import MobileNavbarToggle from "@components/shared/hamburgerMenu";

export default function LcNavbar({ navigationData }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const headerRef = useRef(null);
  const location = useLocation();
  const isProductUpdatesPage = location?.pathname === "/updates/";

  const keyboardFunctions = useCallback((event) => {
    const { key, keyCode } = event;
    if (key === "Escape" || keyCode === 27) {
      setIsMobileMenuOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", keyboardFunctions, false);

    return () => {
      document.removeEventListener("keydown", keyboardFunctions, false);
    };
  }, []);

  // Close mobilemenu when navigating to a new page
  let currentRoute = useLocation();

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [currentRoute]);

  return (
    <header ref={headerRef} className={c.header}>
      <nav>
        <div className={c.container}>
          <MangomintLogo className={c.logo} iconOnlyMobile />
          <Link className={c.lcLogoLink} to={isProductUpdatesPage ? "/updates/" : "/learn/"}>
            {isProductUpdatesPage ? "Platform Updates" : "Learning Center"}
          </Link>
          <LcSearch className={classNames(c.searchCtn, { [c.productUpdatesPage]: isProductUpdatesPage })} />
          {!isProductUpdatesPage && (
            <MobileNavbarToggle
              isActive={isMobileMenuOpen}
              toggleActive={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={c.burger}
            />
          )}
        </div>

        <LcNavigationMobile
          data={navigationData}
          isMenuOpen={isMobileMenuOpen}
          onMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        />
      </nav>
    </header>
  );
}
